import React from "react";
import logo from "../Images/logo.png";
import ButtonArrow from "../components/ButtonArrow";
import CarouselComponent from "../components/CarouselComponent";
// import { useHeader } from "../Contexts/HeaderContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  } from "@fortawesome/free-solid-svg-icons";
import {  } from "@fortawesome/free-regular-svg-icons";
import { faFacebookF, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { Helmet } from "react-helmet";
import logo192 from "../Images/logo192.png";

const Contact = () => {
  // const { marginTop } = useHeader();
  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Contacto Bella Unión – Información y Planificación de Visitas</title>
        <meta
          name="description"
          content="Contáctanos para más información sobre Bella Unión. Estamos aquí para ayudarte a planificar tu visita y responder tus consultas."
        />
        <meta
          name="keywords"
          content="contacto Bella Unión, información turismo Bella Unión, planificar visita Bella Unión, consultas alojamiento, turismo Uruguay"
        />
        <link rel="canonical" href="https://bellaunion.uy/contacto" />
        <meta property="og:title" content="Contacto Bella Unión – Información y Planificación de Visitas" />
        <meta
          property="og:description"
          content="Contáctanos para más información sobre Bella Unión. Estamos aquí para ayudarte a planificar tu visita y responder tus consultas."
        />
        <meta property="og:url" content="https://bellaunion.uy/contacto" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={logo192} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contacto Bella Unión – Información y Planificación de Visitas" />
        <meta
          name="twitter:description"
          content="Contáctanos para más información sobre Bella Unión. Estamos aquí para ayudarte a planificar tu visita y responder tus consultas."
        />
        <meta name="twitter:image" content={logo192} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Contáctanos</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="py-5" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container rounded p-5">
          <div className="row">
            <div className="col">
              <div className="m-auto">
                {/* <h2 className="text-center">Contacto</h2> */}
                <h2 className="text-center">
                  ¿Querés visitar Bella Unión o saber por dónde empezar?
                  <br /> Escribinos y te ayudamos a descubrir todo lo que este destino tiene para ofrecer.
                </h2>
              </div>
              {/* </div>
            <div className="col-md-6 d-flex align-items-center"> */}
              <div className="text-center m-auto">
                {/* <a
                  href="tel:+59892434004"
                  className="d-block mt-4 mb-2 text-decoration-none text-reset d-flex align-items-center justify-content-center"
                >
                  <span className="fs-4">Teléfono: +(598) 92 434 004</span>
                </a> */}
                <a
                  href="mailto:bellaunionturismo@gmail.com"
                  className="d-block mb-3 text-decoration-none text-reset d-flex align-items-center justify-content-center"
                >
                  {/* <FontAwesomeIcon icon={faEnvelope} className="fs-1 me-2" />{" "} */}
                  <span className="fs-4">Email: bellaunionturismo@gmail.com</span>
                </a>
                <img src={logo} alt="Bella Union" className="w-25 mx-auto d-block my-5" />
                {/* <h3 className="mt-4 fs-1">Redes Sociales</h3> */}
                {/* <a
                  href="https://wa.me/59892434004"
                  target="_blanc"
                  className="mb-2 text-decoration-none text-reset"
                >
                  <FontAwesomeIcon
                    icon={faWhatsapp}
                    className="text-success mx-4"
                    style={{ fontSize: "4rem" }}
                  />
                </a> */}
                <a
                  href="https://www.instagram.com/bellaunionturismo/"
                  target="_blanc"
                  className="mb-2 text-decoration-none text-reset"
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    className="text-danger mx-4"
                    style={{ fontSize: "4rem" }}
                  />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61550305677358"
                  target="_blanc"
                  className="mb-2 text-decoration-none text-reset"
                >
                  <FontAwesomeIcon
                    icon={faFacebookF}
                    className="text-primary mx-4"
                    style={{ fontSize: "4rem" }}
                  />
                </a>
                <a
                  href="https://www.tiktok.com/@bellaunionturismorelax"
                  target="_blanc"
                  className="mb-2 text-decoration-none text-reset"
                >
                  <FontAwesomeIcon icon={faTiktok} className="text-dark mx-4" style={{ fontSize: "4rem" }} />
                </a>
              </div>
              {/* <form className="w-100">
                <div className="form-group mb-3">
                  <label htmlFor="name">Nombre</label>
                  <input type="text" name="name" id="name" className="form-control shadow" />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="email">Email</label>
                  <input type="email" name="email" id="email" className="form-control shadow" />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="phone">Teléfono</label>
                  <input type="tel" name="phone" id="phone" className="form-control shadow" />
                </div>
                <div className="text-center mt-2">
                  <button type="submit" className="btn btn-success px-5 ">
                    Enviar
                  </button>
                </div>
              </form> */}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;
